exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entegre[data-v-6c2fad46]{display:inline-block;float:left;text-align:left}.entegre h5[data-v-6c2fad46]{font-size:10px}.btn[data-v-6c2fad46]{margin-top:15px}.entegre img[data-v-6c2fad46]{width:80px;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c2fad46","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Entegrasyon/SantralEntegrasyon.vue
// module id = 486
// module chunks = 0